import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'

const credentialTypes = ['client-id', 'client-secret', 'refresh-token'] as const

export type tfinCredType = (typeof credentialTypes)[number]

export const tfinDocumentTypes = [
  'corrected-bol',
  'customs-documents',
  'inspection-certificate',
  'invoice',
  'letter-of-authority',
  'no-freight-certificate',
  'other',
  'packing-slip',
  'proof-of-delivery',
  'reconsignment-authorization',
  'signed-bol',
  'storage-notification',
  'volume-certificate',
  'weight-and-research-inspection',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const tfin: CarrierDef<tfinCredType> = {
  name: 'TForce Freight',
  scac: 'tfin',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    { id: 'volume', name: 'Volume' },
    {
      id: 'guaranteed_twelve_pm',
      name: 'Guaranteed by Noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
    {
      id: 'guaranteed_five_pm',
      name: 'Guaranteed by 5PM',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
    {
      id: 'accelerated_guaranteed',
      name: 'Accelerated Guaranteed',
      guaranteed: true,
    },
  ],
  credentialTypes,
  legacyCredMap: [
    ['client-id', 'clientId'],
    ['client-secret', 'clientSecret'],
  ],
  credentialConfig: {
    'client-id': { hideFromFreightview: true },
    'client-secret': { hideFromFreightview: true },
  },
  engineLayers: [
    'documents',
    'provisioning',
    'rating',
    'bol',
    'pickup',
    'cancel',
    'profinder',
    'tracking',
  ],
  documentTypes: tfinDocumentTypes,
}
